import { LOCAL_STORAGE_DECLINE_NOTIFICATIONS_KEY } from '../../config/constants';
import localStore from '../../lib/storage/localStore';

const declineNotifications = async (decline = true): Promise<boolean> =>
  await localStore.setItem<boolean>(LOCAL_STORAGE_DECLINE_NOTIFICATIONS_KEY, decline);

export default declineNotifications;
